export default {
  getMessage: field => `O formato deve ser HH:MM de 00:00 até 23:59`,
  validate: (value) => new Promise(resolve => {
    let regex = new RegExp("([0-1][0-9]|2[0-3]):([0-5][0-9])");
    resolve({
      valid: value && regex.test(value)
    });
  })
}